module.exports = __webpack_public_path__ + "img/qepvisualizetree.0141bdf0.png";